import React from 'react';
import { FormTab , TabbedForm , ReferenceArrayInput , Edit  ,TextInput , email , required ,Toolbar, SaveButton, DeleteButton, RadioButtonGroupInput, BooleanInput,CheckboxGroupInput, number, maxLength, SelectInput, ReferenceInput } 
from "react-admin";
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import { ReferenceImageInput, transformReferenceImage } from '../util/referenceImageHelper';
import { Actions, Resources, useHasPermissions } from '../lib/react-admin-loopback';


const useStyles = makeStyles({
    inlineBlock: { display: 'inline-flex', marginRight: '1rem' },
    inlineBlock1: { display: 'flex', flexDirection: 'row' , marginRight: '1rem' },
    cardtitle: {
        fontSize: 14,
      },
    cardlayout : {
        marginBottom : '20px' 
    },
    toolbar: {
        display: 'flex',
        justifyContent: 'space-between',
    },
});
const CustomToolbar = props => (
    <Toolbar {...props} classes={useStyles()}>
        <SaveButton />
        {props.canDelete && <DeleteButton undoable={false} />}
    </Toolbar>
);

export const SupplierEdit = props => {
  
  const hasPermission = useHasPermissions(
    Resources.Supplier, Actions.Edit, 
    () => { 
      alert('권한이 없습니다. ');
      props.history.push('/suppliers');
    }
  );

  const hasDeletePermission = useHasPermissions(
    Resources.Supplier, Actions.Delete,
  );

    const classes = useStyles();
    // 입력값 Validate
    const validateEmail = [required('필수 입력'), email('이메일 형식으로 입력해 주세요')];
    const validateInput= [required('필수 입력')];
    const validateNumber = [number('숫자 만 입력해 주세요') , required('필수 입력')];

    return(
        
    <Edit {...props} transform={transformReferenceImage}>
        <TabbedForm toolbar={<CustomToolbar canDelete={hasDeletePermission} />} variant="outlined" >
            <FormTab label="기본정보">
                <TextInput source ="name" label="상호명" validate={validateInput} fullWidth={true} />
                <TextInput source ="ceoName" label="대표자명" formClassName={classes.inlineBlock}/>
                <TextInput source ="ceoTelNo" label="대표자 연락처(가게 연락처)" formClassName={classes.inlineBlock}/>
                <TextInput source ="ceoEmail" label="대표자 이메일" validate={validateEmail} formClassName={classes.inlineBlock}/>
                <TextInput source ="address" label="위치(주소)" fullWidth={true} 
                  helperText="&#9888; 주소 관리는 Pinks 에서 관리 부탁드립니다"
                />
                <TextInput source ="businessNo" label="사업자번호" validate={validateNumber} />
                <RadioButtonGroupInput source ="curation" fullWidth label="큐레이션" choices={[
                    { id: true , name: 'on' },
                    { id: false , name: 'off' },
                ]} />
                <ReferenceImageInput 
                    label="브랜드 로고" source="logoFile" reference="uploadedFiles" preview="fullPath" addLabel
                />
                <TextInput source ="originInfo" label="원산지 정보" fullWidth={true} />
            </FormTab>

            <FormTab label="영업정보">
                <ReferenceArrayInput  
                    format={v => Array.isArray(v) ? v.map(a => a.id ? a.id: a) : []}
                    parse={ids => ids.map(id => ({id}))} 
                    source ='serviceType'  label="제공 서비스" fullWidth={true} 
                    reference="commonCodes" filter={{type: '07'}} 
                    sort={{ field: 'sort', order: 'ASC' }} validate={validateInput} >
                    <CheckboxGroupInput optionText="desc" validate={validateInput} />
                </ReferenceArrayInput>
                {/* <Card  formClassName={classes.cardlayout} variant="outlined" fullWidth={true}> */}
                <Card className={classes.cardlayout} fullWidth={true} variant="outlined">
                    <CardContent>
                        {/* <Typography formClassName={classes.cardtitle} color="textSecondary" gutterBottom> */}
                        <Typography className={classes.cardtitle} color="textSecondary" gutterBottom>
                            오더가능 요일 (월 ~일)
                        </Typography>
                        <BooleanInput  formClassName={classes.inlineBlock} source="serviceMon" label="월" style={{ display: 'inline', float: 'left', marginLeft: '10px' }}/>
                        <BooleanInput  formClassName={classes.inlineBlock} source="serviceTue" label="화" style={{ display: 'inline', float: 'left', marginLeft: '10px' }}/>
                        <BooleanInput  formClassName={classes.inlineBlock} source="serviceWed" label="수" style={{ display: 'inline', float: 'left', marginLeft: '10px' }}/>
                        <BooleanInput  formClassName={classes.inlineBlock} source="serviceThu" label="목" style={{ display: 'inline', float: 'left', marginLeft: '10px' }}/>
                        <BooleanInput  formClassName={classes.inlineBlock} source="serviceFri" label="금" style={{ display: 'inline', float: 'left', marginLeft: '10px' }}/>
                        <BooleanInput  formClassName={classes.inlineBlock} source="serviceSat" label="토" style={{ display: 'inline', float: 'left', marginLeft: '10px' }}/>
                        <BooleanInput  formClassName={classes.inlineBlock} source="serviceSun" label="일" style={{ display: 'inline', float: 'left', marginLeft: '10px' }}/>
                    </CardContent>
                </Card>
                {/* <Card  formClassName={classes.cardlayout} variant="outlined" fullWidth={true}> */}
                <Card  className={classes.cardlayout} fullWidth variant="outlined">
                    <CardContent>
                        {/* <Typography formClassName={classes.cardtitle} color="textSecondary" gutterBottom> */}
                        <Typography className={classes.cardtitle} color="textSecondary" gutterBottom>
                        오더 가능 유형
                        </Typography>
                        <BooleanInput  source="serviceBreakfast" label="조식" style={{ display: 'inline', float: 'left', marginLeft: '20px' }}/>
                        <BooleanInput  source="serviceLunch" label="중식" style={{ display: 'inline', float: 'left', marginLeft: '20px' }}/>
                        <BooleanInput  source="serviceDinner" label="석식" style={{ display: 'inline', float: 'left', marginLeft: '20px' }}/>
                    </CardContent>
                </Card>
                {/* <TextInput source ="regularFee" label="정기 수수료(VAT별도)" formClassName={classes.inlineBlock}/> */}
                <TextInput source ="serviceFee" label="서비스 수수료(%)" formClassName={classes.inlineBlock} validate={validateNumber}/>
                <TextInput source ="paymentFee" label="결제 수수료(%)" formClassName={classes.inlineBlock} validate={validateNumber}/>
                <TextInput source ="deliveryFee" label="배달비(원)" formClassName={classes.inlineBlock} validate={validateNumber}/>
            </FormTab>
            <FormTab label="사업자 관련정보">
                <ReferenceImageInput 
                    label="사업자등록증" source="businessRegFile" reference="uploadedFiles" preview="fullPath" addLabel
                />
                <TextInput source="invoiceBusinessNo" label="사업자등록번호" validate={maxLength(20)} formClassName={classes.inlineBlock}/>
                <SelectInput source='invoiceBusinessType' label="형태" choices={[
                    {id: 'simplified', name: '간이'},
                    {id: 'general', name: '일반'},
                    {id: 'corporate', name: '법인'}
                ]} formClassName={classes.inlineBlock}/>
                <div/>
                <TextInput source="invoiceCustomerName" label="상호명" validate={maxLength(100)} formClassName={classes.inlineBlock} />
                <TextInput source="invoiceCeoName" label="대표자명" validate={maxLength(20)} formClassName={classes.inlineBlock}/>
                <div/>
                <TextInput source="invoiceEmail" label="이메일" multiline validate={maxLength(100)} />
                <TextInput source="memo" label="비고" fullWidth multiline validate={maxLength(500)} />
            </FormTab>
            <FormTab label="정산 정보">
                {/* <TextInput source ="eventFee" label="이벤트 수수료(VAT별도)" />
                <TextInput source ="eventServiceFee" label="이벤트 서비스 수수료(%)" /> */}
                <TextInput source ="bank" label="은행명" validate={maxLength(50)} />
                <ReferenceInput source ='bankId' label="은행명(코드)" reference="Banks" perPage={100} sort={{order:'desc'}}>
                    <SelectInput  optionText="bankName" />
                </ReferenceInput>
                <TextInput source ="accountHolder" label="예금주" validate={maxLength(100)} />
                <TextInput source ="accountNo" label="계좌번호" validate={maxLength(50)} />
                <BooleanInput  source="cashReceipt" label="현금영수증 발행여부" />
                {/* <TextInput source ="managerName" label="담당자명" /> */}
                {/* <TextInput source ="managerTelNo" label="담당자 연락처"  /> */}
            </FormTab>
{/*             <ReferenceArrayInput source="serviceTypeId" reference="supplierServiceTypes">
                <CheckboxGroupInput  label="가입서비스" choices={[
                    { id: '45', name: '밀박스' },
                    { id: '46', name: '뷔페' },
                    { id: '47', name: '샐러드' },
                ]} />
            </ReferenceArrayInput> */}
            
            {/* <CheckboxGroupInput source="serviceType" label="가입서비스" choices={serviceChoices} optionText="desc" optionValue="type" options={{
  checked: true
}}/> */}
{/*             <CheckboxGroupInput source="accountHolder" label="오더가능요일" formClassName={classes.inlineBlock}  choices={[
                { id: '1', name: '월' },
                { id: '2', name: '화' },
                { id: '3', name: '수' },
                { id: '4', name: '목' },
                { id: '5', name: '금' },
                { id: '6', name: '토' },
                { id: '7', name: '일' },

            ]} />  */}
            

{/*              */}    
        </TabbedForm>
    </Edit>
)};